// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/53e49e4625101110a259.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"a871f504c492c460f743","170":"70fddfab981ac4519f36","171":"057d2eab62ef9beae6d9"}[chunkId] + ".chunk.js";
};